import { MenuItem } from "@mui/material";
import states from "../../services/states";
import WushTextField from "./WushTextField";

export default function WushStateSelect(props) {
  return (
    <WushTextField {...props} select >
      {states.map((state) => (
        <MenuItem key={state.abbreviation} value={state.abbreviation}>
          {state.name}
        </MenuItem>
      ))}
    </WushTextField>
  );
}